import React from "react";
import { CRMProvider } from "./CRMContext";
import CRMShell from "./components/CRMShell";
import "./styles/crm.css";

const ContactBoard = () => {
  return (
    <CRMProvider>
      <CRMShell />
    </CRMProvider>
  );
};

export default ContactBoard;
